import { captureException } from "@sentry/sveltekit";
import { error } from "@sveltejs/kit";

import type { PageLoad } from "./$types";
import { getImageUrl, type PostMetadata } from "../blogHelpers";

export const prerender = "auto";

export const load: PageLoad = async ({ params }) => {
  let module;
  try {
    module = await import(`../../../../lib/blog/${params.slug}.svx`);
  } catch (e) {
    // Added to confirm theory about dynamic imports failing causing 404s.
    // Will remove if there is nothing relevant, because I don't think
    // this should be the pattern.
    captureException(e, {
      extra: {
        slug: params.slug,
        message: "Failed to load blog post",
      },
    });
    error(404);
  }

  // canonical url
  const canonicalUrl = `https://modal.com/blog/${params.slug}`;

  return {
    content: module.default,
    frontmatter: {
      slug: params.slug,
      image: getImageUrl(params.slug),
      ...module.metadata,
    } as PostMetadata,
    ogTitle: module.metadata.title,
    ogDescription: module.metadata.description,
    ogImageUrl:
      "https://modal.com/docs/social-image.png?" +
      new URLSearchParams({
        title: module.metadata.title,
        socialType: "blog",
      }), // TODO https://linear.app/modal-labs/issue/PRD-15/new-blog-post-cover-images-with-auto-generated-ogimages
    title: module.metadata.title + " | Modal Blog",
    canonicalUrl: canonicalUrl,
  };
};
